
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system/migration/migrating-to-v6",
      function () {
        return require("private-next-pages/system/migration/migrating-to-v6.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system/migration/migrating-to-v6"])
      });
    }
  